import * as React from 'react'

import { action, makeObservable, observable } from 'mobx'
import { observer } from 'mobx-react'

import ConfirmDialog from '~/client/src/shared/components/ConfirmDialog/ConfirmDialog'
import {
  Radio,
  RadioGroup,
} from '~/client/src/shared/components/shadcn-ui/radio-group'
import Localization from '~/client/src/shared/localization/LocalizationManager'

interface IProps {
  isShown: boolean
  isRecurringWorkflow: boolean
  onHide(): void
  onApply(thisAndFutureRecurring?: boolean): void

  isDraftWorkflow?: boolean
}

@observer
export default class FormDeleteConfirm extends React.Component<IProps> {
  @observable public thisAndFutureRecurring: boolean = false

  public constructor(props: IProps) {
    super(props)
    makeObservable(this)
  }

  public render() {
    const { isShown, isRecurringWorkflow, onHide, onApply } = this.props

    return (
      <ConfirmDialog
        isOpen={isShown}
        title={Localization.translator.deleteWorkflow}
        doneTitle={`${Localization.translator.yes}, ${Localization.translator.deleteWorkflow}`}
        onCancelClicked={onHide}
        onDoneClicked={() => onApply(this.thisAndFutureRecurring)}
        useRedConfirmationButton
      >
        <div className="tw:text-body-md tw:text-foreground">
          {this.description}
        </div>

        {isRecurringWorkflow && (
          <RadioGroup
            className="tw:my-3 tw:flex tw:flex-col tw:gap-2"
            value={this.thisAndFutureRecurring.toString()}
            onValueChange={this.onChangeRecurringDeletionOption}
          >
            <label className="tw:inline-flex tw:items-center tw:gap-2 tw:cursor-pointer tw:select-none">
              <Radio value="false" />
              <span>{Localization.translator.thisWorkflow}</span>
            </label>
            <label className="tw:inline-flex tw:items-center tw:gap-2 tw:cursor-pointer tw:select-none">
              <Radio value="true" />
              <span>{Localization.translator.thisAndFutureWorkflows}</span>
            </label>
          </RadioGroup>
        )}
      </ConfirmDialog>
    )
  }

  private get description(): JSX.Element {
    const { isDraftWorkflow } = this.props

    if (isDraftWorkflow) {
      return (
        <>
          {
            Localization.translator.draftWorkflowDeletionDialogDescr
              .confirmDelete
          }
        </>
      )
    }
    return (
      <>
        {Localization.translator.workflowDeletionDialogDescr.confirmDelete}
        <br />
        {Localization.translator.workflowDeletionDialogDescr.confirmDelete2}
      </>
    )
  }

  @action.bound
  private onChangeRecurringDeletionOption(value: string) {
    this.thisAndFutureRecurring = value === 'true'
  }
}
